// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DeleteFileDialog {
  background-color: var(--color_neutral_900);
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 32px;
}
.DeleteFileDialog,
.DeleteFileDialog .DeleteFileDialog-header-title {
  color: var(--color_neutral_0);
}
.DeleteFileDialog .DeleteFileDialog-description {
  font-size: 14px;
}
.DeleteFileDialog .DeleteFileDialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 16px;
}`, "",{"version":3,"sources":["webpack://./src/modules/documents/delete-file-dialog/delete-file-dialog.styles.scss"],"names":[],"mappings":"AAAA;EACE,0CAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;AACF;AACE;;EAEE,6BAAA;AACJ;AAEE;EACE,eAAA;AAAJ;AAGE;EACE,aAAA;EACA,yBAAA;EACA,SAAA;AADJ","sourcesContent":[".DeleteFileDialog {\n  background-color: var(--color_neutral_900);\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n  padding: 32px;\n\n  &,\n  .DeleteFileDialog-header-title {\n    color: var(--color_neutral_0);\n  }\n\n  .DeleteFileDialog-description {\n    font-size: 14px;\n  }\n\n  .DeleteFileDialog-footer {\n    display: flex;\n    justify-content: flex-end;\n    gap: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
